import termsJson from './terms.json'
import privacyJson from './privacy.json'
import dataProcessingJson from './data-processing.json'
import { parseLegalDocument } from './legalDocument'
import type { LegalDocument } from './legalDocument'

export type LegalPageId = 'terms' | 'privacy' | 'dataProcessing'

export interface LegalPageEntry {
  readonly id: LegalPageId
  readonly path: string
  readonly document: LegalDocument
}

export const legalPages: Readonly<Record<LegalPageId, LegalPageEntry>> = {
  terms: { id: 'terms', path: '/terms', document: parseLegalDocument(termsJson, 'src/data/legal/terms.json') },
  privacy: { id: 'privacy', path: '/privacy', document: parseLegalDocument(privacyJson, 'src/data/legal/privacy.json') },
  dataProcessing: { id: 'dataProcessing', path: '/data-processing', document: parseLegalDocument(dataProcessingJson, 'src/data/legal/data-processing.json') },
}

/** Display order for routes and footer links. */
export const legalPageList: readonly LegalPageEntry[] = [legalPages.terms, legalPages.privacy, legalPages.dataProcessing]
